import { useEffect, useState } from "react"
import $api from "@/api/index"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"

function Sider() {
  const classnames = classModuleGenerator(styles)
  const [hotspots, setHotspots] = useState([])

  useEffect(() => {
    const getHotList = async () => {
      const { result } = await $api.hotspot
        .list({
          position: "home",
          size: 10,
        })
        .catch((res) => res)
      if (result) setHotspots(result)
    }
    getHotList()
  }, [])

  return (
    <div className={classnames("nav-sider")}>
      <div className={classnames("hot-tit")}>热点关注</div>
      <ul className={classnames("hot-list")}>
        {hotspots.map((item) => {
          return (
            <li key={item._id}>
              <a
                href={item.jumpUrl || null}
                onClick={() => {
                  if (!item.jumpUrl) {
                    window.openJesongChatByGroup(121, 52601)
                    return false
                  }
                }}
              >
                {item.name}
              </a>
              <div className={classnames("hot-content")}>
                <dl>
                  <dt>
                    <a
                      href={item.jumpUrl || null}
                      onClick={() => {
                        if (!item.jumpUrl) {
                          window.openJesongChatByGroup(121, 52601)
                          return false
                        }
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={item.coverUrl} alt="" />
                    </a>
                  </dt>
                  <dd className={classnames("hot-content-tit")}>{item.name}</dd>
                  <dd
                    className={classnames("hot-content-intro")}
                    title={item.intro}
                  >
                    {item.intro}
                  </dd>
                  <dd>
                    <a
                      className={classnames("hot-btn")}
                      href={item.jumpUrl || null}
                      onClick={() => {
                        if (!item.jumpUrl) {
                          window.openJesongChatByGroup(121, 52601)
                          return false
                        }
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.jumpGuide || "点击了解"}
                    </a>
                  </dd>
                </dl>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default Sider

// export class navSider extends Component {
//   constructor() {
//     super()
//     this.state = {
//       hotspots: [],
//     }
//   }

//   componentDidMount() {
//     this.getHotList()
//   }

//   async getHotList() {
//     const { result } = await $api.hotspot
//       .list({
//         position: "home",
//         size: 10,
//       })
//       .catch((res) => res)
//     if (result)
//       this.setState({
//         hotspots: result,
//       })
//   }

//   render() {
//     return (

//     )
//   }
// }

// export default navSider
